/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Icon from 'src/components/Icon/Icon';
import BallsContainer from '../BallsContainer/BallsContainer';
import './NumberBetDetails.scss';
import NumberBetContext from '../../Context/NumberBet.context';


interface NumberBetDetailsProps {
  marketName: string,
  outcome: string,
  odds: number,
  index: number,
  oddsChanged: string
  selectedSlip: number,
  totalCombinations: number,
  selectedNumbers: {type: string, number: number, isBanker: boolean, color:string }[]
  isSuspended: boolean
  banker: boolean,
  sameBallset: boolean,
  permutationsCount?: number
}

function NumberBetDetails({
  marketName,
  odds,
  index,
  oddsChanged,
  totalCombinations,
  banker,
  isSuspended
}: NumberBetDetailsProps) {
  const dispatch = useDispatch();

  const {
    selectedSlip,
    setBanker
  } = useContext(NumberBetContext);

  return (
    <div className="numberbet-details">
      <div className="numberbet-details__market">
        {
          (selectedSlip === 2 || (selectedSlip === 1 && totalCombinations > 1)) && (
            <span
              className={ classNames('numberbet-details__banker', { 'numberbet-details__banker--selected': banker }) }
              onClick={ () => setBanker(!banker) }
            >
                B
            </span>
          )
        }
        <span className="numberbet-details__index">{ index +1 }.</span>
        <span className="numberbet-details__market-name">{ marketName }</span>
      </div>
      <div className="numberbet-details__odds-container">
        <span className={
          classNames({
            'numberbet-details__odds': true,
            'numberbet-details__odds--increased': oddsChanged === 'increased',
            'numberbet-details__odds--decreased': oddsChanged === 'decreased'
          })
        }
        >
          {
            oddsChanged &&
          <div className={
            classNames({
              'numberbet-details__arrow': true,
              'numberbet-details__arrow--up': oddsChanged === 'increased',
              'numberbet-details__arrow--down': oddsChanged === 'decreased'
            })
          }
          />
          }

          { odds }
        </span>
        <Icon
          icon="trash"
          className={
            classNames({
              'numberbet-details__clear': true,
              'numberbet-details__clear--highlight': isSuspended
            })
          }
          onClick={ () => dispatch.betslip.removeBetAtIndex(index) }
        />
      </div>
    </div>
  );
}

export default NumberBetDetails;
